import 'babel-polyfill'
import objectFitImages from 'object-fit-images'

import './content'
import './selects'
import './front-page'
import './header'
import './load-more'
import './members'

objectFitImages()

jQuery(document).ready(function () {

    if( typeof gform !== 'undefined' ) {
        gform.addFilter( 'gform_file_upload_markup', function (html, file, up, strings, imagesUrl){
            var formId = up.settings.multipart_params.form_id,
                fieldId = up.settings.multipart_params.field_id;
                html =
                  "<strong>" +
                  file.name +
                  " </strong>" +
                  "<div class='gform_delete' onclick='gformDeleteUploadedFile(" +
                  formId +
                  "," +
                  fieldId +
                  ", this);'></div>";
                    

            return html;
        });
    }

})
